
/**
 * Version Management System
 * 
 * This file serves as the single source of truth for application versioning.
 * It provides utilities for version tracking and comparison to prevent caching issues.
 */

// Get build ID from environment or generate a fallback using timestamp for uniqueness
export const BUILD_ID = import.meta.env.VITE_BUILD_ID || 
  `${new Date().toISOString().split('T')[0].replace(/-/g, '')}-${Date.now().toString().slice(-6)}`;

// Format: YYYYMMDD-COUNTER (counter is added by the build system or timestamp)
export const APP_VERSION = BUILD_ID;

// Add version parameter to URLs (only for dynamic resources)
export const addVersionToUrl = (url: string): string => {
  try {
    if (!url || 
        url.startsWith('data:') ||
        url.includes('_v=') || 
        url.includes('?v=') ||
        !url.startsWith('/')) {
      return url;
    }
    
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}_v=${APP_VERSION}-${Date.now().toString().slice(-6)}`;
  } catch (e) {
    return url;
  }
};

// Check if current URL has cache busting parameters
export const hasVersionParam = (): boolean => {
  return window.location.href.includes('_v=') || 
         window.location.href.includes('_cache=');
};

// Clean URL by removing version parameters
export const cleanVersionParams = (url: string): string => {
  try {
    const urlObj = new URL(url);
    urlObj.searchParams.delete('_v');
    urlObj.searchParams.delete('_cache');
    return urlObj.toString();
  } catch (e) {
    // Fallback for older browsers
    return url.replace(/[\?&]_v=[^&]+/, '')
              .replace(/[\?&]_cache=[^&]+/, '');
  }
};
